import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DataImportService } from '../services/data-import.service';
import { DataImportErrorDialog } from '../../../components/shared/data-import-error-dialog/data-import-error-dialog';
import {FileImportError} from "../types/data-import/file-import-error";

@Component({
  selector: 'app-data-import-dialog',
  templateUrl: './data-import-dialog.component.html',
  styleUrls: ['./data-import-dialog.component.scss'],
})
export class DataImportDialogComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload!: ElementRef<HTMLInputElement>;
  selectedOption!: string;
  options: { value: string; type: string }[] = [];
  addedFiles: File[] = [];
  isUploadDisabled = true;
  isFileUploadEnabled = false;
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<DataImportDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      fileTypes: { value: string; type: string }[];
    },
    private dataImportService: DataImportService,
    public dialog: MatDialog
  ) {
    this.options = data.fileTypes;
  }

  ngOnInit(): void {}

  handleFileInput(event: Event) {
    const eventTarget = (event.target as HTMLInputElement).files as FileList;
    if (eventTarget) {
      Array.prototype.forEach.call(eventTarget, (file: File) => {
        this.addedFiles.push(file);
      });
      this.isUploadDisabled = false;
    }
  }

  getAcceptType(selectedOption: string): string {
    const option = this.options.find((opt) => opt.value === selectedOption);
    return option ? option.type : '';
  }

  onFileTypeChange(): void {
    this.isFileUploadEnabled = this.selectedOption === 'Orlen' || this.selectedOption === 'ACMI';
    this.addedFiles = [];
    this.isUploadDisabled = true;
  }

  removeFile(file: File, index: number) {
    this.addedFiles.splice(index, 1);
    if (this.addedFiles.length === 0) {
      this.isUploadDisabled = true;
      this.fileUpload.nativeElement.value = '';
    }
  }

  onUploadFile() {
    if (this.addedFiles.length > 0) {
      const selectedFile = this.addedFiles[0];
      this.isLoading = true;

      if (this.selectedOption === 'Orlen') {
        this.dataImportService.addOrlen(selectedFile).subscribe({
          next: () => {
            this.dialogRef.close();
            this.isLoading = false;
          },
          error: (error) => {
            if (error.error) {
              const importError = error.error as FileImportError;

              this.dialog.open(DataImportErrorDialog, {
                data: importError
              });
            } else {
              this.handleError(error);
            }
            this.isLoading = false;
          },
        });
      } else if (this.selectedOption === 'ACMI') {
        this.dataImportService.addAcmi(selectedFile).subscribe({
          next: () => {
            this.dialogRef.close();
            this.isLoading = false;
          },
          error: (error) => {
            if (error.error) {
              const importError = error.error as FileImportError;

              this.dialog.open(DataImportErrorDialog, {
                data: importError
              });
            } else {
              this.handleError(error);
            }
            this.isLoading = false;
          },
        });
      }
    }
  }

  private handleError(error: any) {
    this.dialog.open(DataImportErrorDialog, {
      data: { message: error.error.Message },
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
